import client from '../httpClient';

const getResponsesRecentListApi = async (params) => {
  const res = await client.get('/responses/recent-list/', { params });
  return res;
};

export default getResponsesRecentListApi;
